import React from "react";
import "../../../assets/styles/components/utils/atoms/button.scss";

const IconButton = (props) => {
  switch (props.type) {
    case "search":
      return (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="22" cy="22" r="21.6" stroke="#1D1D1D" strokeWidth="0.8" />
          <path
            d="M26.2939 24.5786H25.3905L25.0703 24.2699C26.191 22.9663 26.8656 21.2739 26.8656 19.4328C26.8656 15.3276 23.538 12 19.4328 12C15.3276 12 12 15.3276 12 19.4328C12 23.538 15.3276 26.8656 19.4328 26.8656C21.2739 26.8656 22.9663 26.191 24.2699 25.0703L24.5786 25.3905V26.2939L30.2962 32L32 30.2962L26.2939 24.5786ZM19.4328 24.5786C16.5855 24.5786 14.287 22.2802 14.287 19.4328C14.287 16.5855 16.5855 14.287 19.4328 14.287C22.2802 14.287 24.5786 16.5855 24.5786 19.4328C24.5786 22.2802 22.2802 24.5786 19.4328 24.5786Z"
            fill="#1D1D1D"
          />
        </svg>
      );
      break;
    case "search-mobile":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.2939 12.5786H13.3905L13.0703 12.2699C14.191 10.9663 14.8656 9.27387 14.8656 7.43282C14.8656 3.32762 11.538 0 7.43282 0C3.32762 0 0 3.32762 0 7.43282C0 11.538 3.32762 14.8656 7.43282 14.8656C9.27387 14.8656 10.9663 14.191 12.2699 13.0703L12.5786 13.3905V14.2939L18.2962 20L20 18.2962L14.2939 12.5786ZM7.43282 12.5786C4.58548 12.5786 2.28702 10.2802 2.28702 7.43282C2.28702 4.58548 4.58548 2.28702 7.43282 2.28702C10.2802 2.28702 12.5786 4.58548 12.5786 7.43282C12.5786 10.2802 10.2802 12.5786 7.43282 12.5786Z"
            fill="white"
          />
        </svg>
      );
      break;
    case "cart":
      return (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="22" cy="22" r="21.6" stroke="#1D1D1D" strokeWidth="0.8" />
          <path
            d="M28 16H26C26 13.79 24.21 12 22 12C19.79 12 18 13.79 18 16H16C14.9 16 14 16.9 14 18V30C14 31.1 14.9 32 16 32H28C29.1 32 30 31.1 30 30V18C30 16.9 29.1 16 28 16ZM20 20C20 20.55 19.55 21 19 21C18.45 21 18 20.55 18 20V18H20V20ZM22 14C23.1 14 24 14.9 24 16H20C20 14.9 20.9 14 22 14ZM26 20C26 20.55 25.55 21 25 21C24.45 21 24 20.55 24 20V18H26V20Z"
            fill="#1D1D1D"
          />
        </svg>
      );
      break;
    case "cart-mobile":
      return (
        <svg
          width="14"
          height="18"
          viewBox="0 0 14 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.25 3.6H10.5C10.5 1.611 8.93375 0 7 0C5.06625 0 3.5 1.611 3.5 3.6H1.75C0.7875 3.6 0 4.41 0 5.4V16.2C0 17.19 0.7875 18 1.75 18H12.25C13.2125 18 14 17.19 14 16.2V5.4C14 4.41 13.2125 3.6 12.25 3.6ZM5.25 7.2C5.25 7.695 4.85625 8.1 4.375 8.1C3.89375 8.1 3.5 7.695 3.5 7.2V5.4H5.25V7.2ZM7 1.8C7.9625 1.8 8.75 2.61 8.75 3.6H5.25C5.25 2.61 6.0375 1.8 7 1.8ZM10.5 7.2C10.5 7.695 10.1062 8.1 9.625 8.1C9.14375 8.1 8.75 7.695 8.75 7.2V5.4H10.5V7.2Z"
            fill="#1D1D1D"
          />
        </svg>
      );
      break;
    case "profile":
      return (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="22" cy="22" r="21.6" stroke="#1D1D1D" strokeWidth="0.8" />
          <path
            d="M22 22C24.21 22 26 20.21 26 18C26 15.79 24.21 14 22 14C19.79 14 18 15.79 18 18C18 20.21 19.79 22 22 22ZM22 24C19.33 24 14 25.34 14 28V30H30V28C30 25.34 24.67 24 22 24Z"
            fill="#1D1D1D"
          />
        </svg>
      );
      break;
    case "profile-mobile":
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 10C5.33 10 0 11.34 0 14V16H16V14C16 11.34 10.67 10 8 10Z"
            fill="#1D1D1D"
          />
        </svg>
      );
      break;
    case "burger":
      return (
        <svg
          width="20"
          height="14"
          viewBox="0 0 20 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 14H20V11.6667H0V14ZM0 8.16667H20V5.83333H0V8.16667ZM0 0V2.33333H20V0H0Z"
            fill="black"
          />
        </svg>
      );
      break;
    case "facebook":
      return (
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-label="facebook-icon"
        >
          <circle cx="28" cy="28" r="27.5" stroke="white" />
          <path
            d="M37.3333 16H18.6667C17.1933 16 16 17.1933 16 18.6667V37.3333C16 38.8067 17.1933 40 18.6667 40H28.828V30.7187H25.704V27.0853H28.828V24.412C28.828 21.3133 30.7227 19.624 33.488 19.624C34.42 19.6213 35.3507 19.6693 36.2773 19.764V23.004H34.3733C32.8667 23.004 32.5733 23.716 32.5733 24.7667V27.08H36.1733L35.7053 30.7133H32.552V40H37.3333C38.8067 40 40 38.8067 40 37.3333V18.6667C40 17.1933 38.8067 16 37.3333 16Z"
            fill="white"
          />
        </svg>
      );
      break;
    case "instagram":
      return (
        <svg
          width="57"
          height="56"
          viewBox="0 0 57 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-label="instagram-icon"
        >
          <circle cx="28.3638" cy="28" r="27.5" stroke="white" />
          <path
            d="M22.6667 16C18.9853 16 16 18.9853 16 22.6667V33.3333C16 37.0147 18.9853 40 22.6667 40H33.3333C37.0147 40 40 37.0147 40 33.3333V22.6667C40 18.9853 37.0147 16 33.3333 16H22.6667ZM36 18.6667C36.736 18.6667 37.3333 19.264 37.3333 20C37.3333 20.736 36.736 21.3333 36 21.3333C35.264 21.3333 34.6667 20.736 34.6667 20C34.6667 19.264 35.264 18.6667 36 18.6667ZM28 21.3333C31.6813 21.3333 34.6667 24.3187 34.6667 28C34.6667 31.6813 31.6813 34.6667 28 34.6667C24.3187 34.6667 21.3333 31.6813 21.3333 28C21.3333 24.3187 24.3187 21.3333 28 21.3333ZM28 24C26.9391 24 25.9217 24.4214 25.1716 25.1716C24.4214 25.9217 24 26.9391 24 28C24 29.0609 24.4214 30.0783 25.1716 30.8284C25.9217 31.5786 26.9391 32 28 32C29.0609 32 30.0783 31.5786 30.8284 30.8284C31.5786 30.0783 32 29.0609 32 28C32 26.9391 31.5786 25.9217 30.8284 25.1716C30.0783 24.4214 29.0609 24 28 24Z"
            fill="white"
          />
        </svg>
      );
      break;
    case "youtube":
      return (
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-label="youtube-icon"
        >
          <circle cx="28" cy="28" r="27.5" stroke="white" />
          <path
            d="M19.5729 14.6666L21.5443 21.7916V25.2083H23.2526V21.7916L25.25 14.6666H23.5286L22.8125 17.9088C22.6112 18.8555 22.4831 19.5283 22.4245 19.9296H22.3724C22.2884 19.3683 22.1604 18.6905 21.9844 17.8958L21.2943 14.6666H19.5729ZM27.2422 17.3567C26.6635 17.3567 26.1971 17.4698 25.8411 17.7005C25.4851 17.9298 25.2227 18.2968 25.0547 18.7994C24.888 19.3021 24.8047 19.9675 24.8047 20.7968V21.9166C24.8047 22.7366 24.8768 23.3933 25.0234 23.888C25.1701 24.3826 25.4176 24.7471 25.7656 24.9817C26.1136 25.2164 26.5925 25.3333 27.2031 25.3333C27.7978 25.3333 28.2705 25.2176 28.6172 24.9869C28.9639 24.7563 29.2151 24.3945 29.3698 23.8958C29.5245 23.3971 29.6016 22.738 29.6016 21.9166V20.7968C29.6016 19.9688 29.5233 19.3059 29.3646 18.8073C29.2059 18.3099 28.9534 17.943 28.6094 17.7083C28.2654 17.4736 27.8115 17.3567 27.2422 17.3567ZM30.5052 17.5078V23.2604C30.5052 23.9724 30.6245 24.496 30.8672 24.8307C31.1099 25.1654 31.4867 25.3333 31.9974 25.3333C32.7334 25.3333 33.2882 24.9776 33.6562 24.2656H33.6927L33.8438 25.2083H35.2005V17.5078H33.4688V23.625C33.4021 23.7676 33.3001 23.8845 33.1615 23.9765C33.0228 24.0699 32.8798 24.1145 32.7292 24.1145C32.5532 24.1145 32.4276 24.0425 32.3516 23.8958C32.2756 23.7491 32.237 23.5028 32.237 23.1588V17.5078H30.5052ZM27.2031 18.5494C27.4458 18.5494 27.6175 18.6763 27.7135 18.9323C27.8095 19.1869 27.8568 19.5925 27.8568 20.1458V22.5442C27.8568 23.1136 27.8095 23.5253 27.7135 23.776C27.6175 24.0267 27.4471 24.1523 27.2057 24.1536C26.9631 24.1536 26.7951 24.0267 26.7031 23.776C26.6098 23.5253 26.5651 23.1136 26.5651 22.5442V20.1458C26.5651 19.5938 26.6123 19.1883 26.7083 18.9323C26.8043 18.6776 26.9685 18.5494 27.2031 18.5494ZM18.6667 26.6666C17.2 26.6666 16 27.8666 16 29.3333V38.6666C16 40.1333 17.2 41.3333 18.6667 41.3333H37.3333C38.8 41.3333 40 40.1333 40 38.6666V29.3333C40 27.8666 38.8 26.6666 37.3333 26.6666H18.6667ZM28.0651 29.3333H29.474V32.7578H29.4844C29.611 32.5098 29.7927 32.3108 30.026 32.1588C30.2594 32.0068 30.5119 31.9323 30.7813 31.9323C31.1279 31.9323 31.399 32.0243 31.5964 32.2083C31.7937 32.3923 31.938 32.6896 32.026 33.0989C32.114 33.5096 32.1562 34.0793 32.1563 34.8073V35.8359H32.1589C32.1589 36.8052 32.0406 37.5153 31.8073 37.9713C31.574 38.4273 31.2108 38.6562 30.7161 38.6562C30.4401 38.6562 30.1902 38.5928 29.9635 38.4661C29.7369 38.3394 29.5665 38.1653 29.4531 37.9453H29.4219L29.2734 38.5599H28.0651V29.3333ZM19.3151 29.6614H23.651V30.8411H22.1979V38.5599H20.7682V30.8411H19.3151V29.6614ZM34.7969 31.9349C35.2982 31.9349 35.6838 32.0269 35.9531 32.2109C36.2211 32.3949 36.4102 32.6823 36.5208 33.0703C36.6302 33.4596 36.6849 33.9969 36.6849 34.6823V35.7968H34.237V36.1276C34.237 36.5449 34.2481 36.8571 34.2734 37.0651C34.2988 37.2731 34.3498 37.4261 34.4271 37.5208C34.5044 37.6168 34.6238 37.664 34.7865 37.664C35.0051 37.664 35.1556 37.5781 35.237 37.4088C35.3183 37.2395 35.3631 36.9585 35.3698 36.5625L36.6328 36.6354C36.6395 36.6914 36.6432 36.7711 36.6432 36.8698C36.6432 37.4711 36.4778 37.9201 36.1484 38.2161C35.8191 38.5134 35.3565 38.6614 34.7552 38.6614C34.0339 38.6614 33.5276 38.4337 33.237 37.9817C32.9463 37.5297 32.8021 36.8308 32.8021 35.8828V34.7474C32.8021 33.7714 32.9526 33.0587 33.2526 32.6093C33.5526 32.16 34.0689 31.9349 34.7969 31.9349ZM23.2135 32.0599H24.6797V36.8333C24.6797 37.1226 24.712 37.3304 24.776 37.4531C24.84 37.5771 24.9444 37.638 25.0938 37.638C25.2204 37.638 25.3449 37.5995 25.4609 37.5208C25.5783 37.4435 25.6614 37.3439 25.7187 37.2239V32.0599H27.1849V38.5599H27.1823H26.0365L25.9115 37.763H25.8776C25.5656 38.3656 25.0992 38.6666 24.4766 38.6666C24.0446 38.6666 23.7288 38.5248 23.5234 38.2421C23.3181 37.9595 23.2135 37.5166 23.2135 36.9166V32.0599ZM34.7656 32.9244C34.6096 32.9244 34.4939 32.9718 34.4193 33.0625C34.3446 33.1545 34.2948 33.305 34.2708 33.513C34.2455 33.721 34.2344 34.0369 34.2344 34.4609V34.927H35.3047V34.4609C35.3047 34.0436 35.291 33.729 35.263 33.513C35.2364 33.297 35.184 33.1453 35.1094 33.0573C35.0347 32.9693 34.9216 32.9244 34.7656 32.9244ZM30.1224 32.9713C29.9811 32.9713 29.8518 33.0273 29.7318 33.1406C29.6118 33.2539 29.5259 33.3995 29.4766 33.5755V37.2656C29.5406 37.3789 29.6239 37.4635 29.7266 37.5208C29.8292 37.5768 29.9386 37.6067 30.0599 37.6067C30.2159 37.6067 30.3377 37.5508 30.4297 37.4375C30.5217 37.3241 30.5889 37.1339 30.6276 36.8645C30.6663 36.5965 30.6849 36.2233 30.6849 35.75V34.914C30.6849 34.4047 30.67 34.0129 30.638 33.7369C30.606 33.4609 30.5487 33.2618 30.4687 33.1458C30.3874 33.0298 30.2717 32.9713 30.1224 32.9713Z"
            fill="white"
          />
        </svg>
      );
      break;
    case "video":
      return (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="22" cy="22" r="21.6" stroke="#1D1D1D" strokeWidth="0.8" />
          <path
            d="M22 12C16.48 12 12 16.48 12 22C12 27.52 16.48 32 22 32C27.52 32 32 27.52 32 22C32 16.48 27.52 12 22 12ZM20 26.5V17.5L26 22L20 26.5Z"
            fill="#1D1D1D"
          />
        </svg>
      );
      break;
    case "wish-big":
      return (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="22" cy="22" r="21.6" stroke="#1D1D1D" strokeWidth="0.8" />
          <path
            d="M22 34L20.26 32.4174C14.08 26.8185 10 23.1259 10 18.594C10 14.9014 12.904 12 16.6 12C18.688 12 20.692 12.9711 22 14.5057C23.308 12.9711 25.312 12 27.4 12C31.096 12 34 14.9014 34 18.594C34 23.1259 29.92 26.8185 23.74 32.4294L22 34Z"
            fill="#1D1D1D"
          />
        </svg>
      );
      break;
    case "modal-cross":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M20 2.01429L17.9857 0L10 7.98571L2.01429 0L0 2.01429L7.98571 10L0 17.9857L2.01429 20L10 12.0143L17.9857 20L20 17.9857L12.0143 10L20 2.01429Z"
            fill="white"
          />
        </svg>
      );
      break;
    case "share-facebook":
      return (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="22"
            cy="22"
            r="21.6"
            fill="#1D1D1D"
            stroke="#1D1D1D"
            strokeWidth="0.8"
          />
          <path
            d="M29 13H15C13.895 13 13 13.895 13 15V29C13 30.105 13.895 31 15 31H22.621V24.039H20.278V21.314H22.621V19.309C22.621 16.985 24.042 15.718 26.116 15.718C26.815 15.716 27.513 15.752 28.208 15.823V18.253H26.78C25.65 18.253 25.43 18.787 25.43 19.575V21.31H28.13L27.779 24.035H25.414V31H29C30.105 31 31 30.105 31 29V15C31 13.895 30.105 13 29 13Z"
            fill="white"
          />
        </svg>
      );
      break;
    case "share-twitter":
      return (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="22"
            cy="22"
            r="21.6"
            fill="#1D1D1D"
            stroke="#1D1D1D"
            strokeWidth="0.8"
          />
          <path
            d="M32.4004 15.5496C31.6348 15.8896 30.8124 16.1184 29.9492 16.2216C30.8308 15.6936 31.5068 14.8576 31.8252 13.8608C31.0012 14.3496 30.0876 14.7048 29.1148 14.8968C28.3364 14.0672 27.2276 13.5488 26.0004 13.5488C23.6436 13.5488 21.7332 15.46 21.7332 17.816C21.7332 18.1504 21.7716 18.4768 21.8436 18.788C18.2972 18.6104 15.1532 16.9112 13.0476 14.3288C12.6812 14.9592 12.4708 15.692 12.4708 16.4752C12.4708 17.9552 13.2236 19.2616 14.3684 20.0264C13.6692 20.004 13.0108 19.812 12.4356 19.4928C12.4356 19.5112 12.4356 19.528 12.4356 19.5464C12.4356 21.6144 13.906 23.3392 15.8588 23.7304C15.5012 23.828 15.1236 23.88 14.734 23.88C14.4596 23.88 14.1916 23.8528 13.9316 23.804C14.4748 25.4992 16.0508 26.7336 17.918 26.768C16.458 27.9128 14.618 28.5952 12.618 28.5952C12.274 28.5952 11.934 28.5752 11.5996 28.5352C13.4884 29.7456 15.7308 30.452 18.1412 30.452C25.9908 30.452 30.282 23.9496 30.282 18.3104C30.282 18.1256 30.278 17.9416 30.27 17.7584C31.1044 17.156 31.8284 16.4048 32.4004 15.5496Z"
            fill="white"
          />
        </svg>
      );
      break;
    case "share-link":
      return (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="22"
            cy="22"
            r="21.6"
            fill="#1D1D1D"
            stroke="#1D1D1D"
            strokeWidth="0.8"
          />
          <path
            d="M12.28 22C12.28 19.948 13.948 18.28 16 18.28H20.8V16H16C12.688 16 10 18.688 10 22C10 25.312 12.688 28 16 28H20.8V25.72H16C13.948 25.72 12.28 24.052 12.28 22ZM17.2 23.2H26.8V20.8H17.2V23.2ZM28 16H23.2V18.28H28C30.052 18.28 31.72 19.948 31.72 22C31.72 24.052 30.052 25.72 28 25.72H23.2V28H28C31.312 28 34 25.312 34 22C34 18.688 31.312 16 28 16Z"
            fill="white"
          />
        </svg>
      );
      break;
    case "reset":
      return (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="22" cy="22" r="21.6" stroke="#1D1D1D" strokeWidth="0.8" />
          <path
            d="M30.9091 17L25.8182 22H29.6364C29.6364 26.1375 26.2127 29.5 22 29.5C20.7145 29.5 19.4927 29.1875 18.4364 28.625L16.5782 30.45C18.1436 31.425 20.0018 32 22 32C27.6255 32 32.1818 27.525 32.1818 22H36L30.9091 17ZM14.3636 22C14.3636 17.8625 17.7873 14.5 22 14.5C23.2855 14.5 24.5073 14.8125 25.5636 15.375L27.4218 13.55C25.8564 12.575 23.9982 12 22 12C16.3745 12 11.8182 16.475 11.8182 22H8L13.0909 27L18.1818 22H14.3636Z"
            fill="black"
          />
        </svg>
      );
      break;
      case "white-slider-next":
        return (
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="bi-slider-next"
            {...props}
          >
            <circle cx="20" cy="20" r="20" fill="#1D1D1D" stroke="white" strokeWidth="0.8"/>
            <path
              d="M20 12L18.59 13.41L24.17 19L12 19L12 21L24.17 21L18.58 26.58L20 28L28 20L20 12Z"
              fill="#FFF5E5"
            />
          </svg>
        );
        break;
      case "white-slider-prev":
        return (
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="bi-slider-prev"
            {...props}
          >
            <circle cx="20" cy="20" r="20" fill="#1D1D1D" stroke="white" strokeWidth="0.8"/>
            <path
              d="M20 28L21.41 26.59L15.83 21L28 21L28 19L15.83 19L21.42 13.42L20 12L12 20L20 28Z"
              fill="#FFF5E5"
            />
          </svg>
        );
        break;
    case "slider-next":
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="bi-slider-next"
        >
          <circle cx="20" cy="20" r="20" fill="#1D1D1D" />
          <path
            d="M20 12L18.59 13.41L24.17 19L12 19L12 21L24.17 21L18.58 26.58L20 28L28 20L20 12Z"
            fill="#FFF5E5"
          />
        </svg>
      );
      break;
    case "slider-prev":
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="bi-slider-prev"
        >
          <circle cx="20" cy="20" r="20" fill="#1D1D1D" />
          <path
            d="M20 28L21.41 26.59L15.83 21L28 21L28 19L15.83 19L21.42 13.42L20 12L12 20L20 28Z"
            fill="#FFF5E5"
          />
        </svg>
      );
      break;
    case "outline-slider-next":
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <circle cx="20" cy="20" r="19.6" stroke="transparent" strokeWidth="0.8" />
          <path
            d="M20 12L18.59 13.4315L24.17 19.107L12 19.107L12 21.1376L24.17 21.1376L18.58 26.8029L20 28.2446L28 20.1223L20 12Z"
            fill="black"
          />
        </svg>
      );
      break;
    case "outline-slider-prev":
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <circle
            cx="20"
            cy="20"
            r="19.6"
            transform="rotate(-180 20 20)"
            stroke="transparent"
            strokeWidth="0.8"
          />
          <path
            d="M20 28.2446L21.41 26.8131L15.83 21.1376L28 21.1376L28 19.107L15.83 19.107L21.42 13.4417L20 12L12 20.1223L20 28.2446Z"
            fill="black"
          />
        </svg>
      );
      break;
    case "resetBtnMobile":
      return (
        <svg
          width="28"
          height="20"
          viewBox="0 0 28 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.9091 5L17.8182 10H21.6364C21.6364 14.1375 18.2127 17.5 14 17.5C12.7145 17.5 11.4927 17.1875 10.4364 16.625L8.57818 18.45C10.1436 19.425 12.0018 20 14 20C19.6255 20 24.1818 15.525 24.1818 10H28L22.9091 5ZM6.36364 10C6.36364 5.8625 9.78727 2.5 14 2.5C15.2855 2.5 16.5073 2.8125 17.5636 3.375L19.4218 1.55C17.8564 0.575 15.9982 0 14 0C8.37455 0 3.81818 4.475 3.81818 10H0L5.09091 15L10.1818 10H6.36364Z"
            fill="black"
          />
        </svg>
      );
      break;
    case "filterBtnMobile":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 15.5556V17.7778H6.66667V15.5556H0ZM0 2.22222V4.44444H11.1111V2.22222H0ZM11.1111 20V17.7778H20V15.5556H11.1111V13.3333H8.88889V20H11.1111ZM4.44444 6.66667V8.88889H0V11.1111H4.44444V13.3333H6.66667V6.66667H4.44444ZM20 11.1111V8.88889H8.88889V11.1111H20ZM13.3333 6.66667H15.5556V4.44444H20V2.22222H15.5556V0H13.3333V6.66667Z"
            fill="black"
          />
        </svg>
      );
      break;
    default:
      return "";
      break;
  }
};

export default IconButton;
